import { ChangeEvent, Dispatch, ReactNode, useId, useMemo } from 'react';
import { TransactionsDateFilterDialogLabel } from './TransactionsDateFilterDialogLabel';
import { TransactionsDateFilterDialogFromGroup } from './TransactionsDateFilterDialogFromGroup';
import './TransactionsDateFilterDialogDateRange.scss';
import { isDateValid } from '../../../functions/isDateValid';
import { OptionalDateRange } from '../../../components/table/interfaces/OptionalDateRange';
import format from 'date-fns/format';

export function TransactionsDateFilterDialogDateRange({
  label,
  value,
  onValueChange,
}: {
  label: ReactNode;
  value: OptionalDateRange | null;
  onValueChange: Dispatch<OptionalDateRange | null>;
}) {
  const controlId = useId();

  const onChange = ({ target }: ChangeEvent<HTMLInputElement>, setDate: Dispatch<Date | null>) => {
    if (target.value) {
      const date = new Date(target.value);

      if (isDateValid(date)) {
        return setDate(date);
      }
    }

    setDate(null);
  };

  const setRange = (range: OptionalDateRange) => {
    onValueChange(range[0] === null && range[1] === null ? null : range);
  };

  const startDefaultValue = useMemo(() => (value && value[0] ? format(value[0], 'yyyy-MM-dd') : undefined), [value]);
  const endDefaultValue = useMemo(() => (value && value[1] ? format(value[1], 'yyyy-MM-dd') : undefined), [value]);

  return (
    <TransactionsDateFilterDialogFromGroup>
      <TransactionsDateFilterDialogLabel htmlFor={controlId}>{label}</TransactionsDateFilterDialogLabel>

      <div className="TransactionsDateFilterDialogDateRange">
        <input
          className="form-control form-control-sm"
          type="date"
          size={10}
          defaultValue={startDefaultValue}
          onChange={(event) => onChange(event, (date) => setRange(value ? [date, value[1]] : [date, null]))}
          id={controlId}
        />
        &ndash;
        <input
          className="form-control form-control-sm"
          type="date"
          size={10}
          defaultValue={endDefaultValue}
          onChange={(event) => onChange(event, (date) => setRange(value ? [value[0], date] : [null, date]))}
        />
      </div>
    </TransactionsDateFilterDialogFromGroup>
  );
}
